import React, { PureComponent } from 'react';
import Button from './Button';

class ButtonPrimary extends PureComponent {
    state = {};

    render() {
        let { classes = [], ...props } = this.props;
        return (
            <Button {...props} classes={['fm-button__primary', ...classes]} loadingColor="white" />
        );
    }
}

export default ButtonPrimary;
